import { useState } from "react";

/**
 * LoginPage (Iter 27.1) — Google-only sign-in via Emergent-managed OAuth.
 * Password login was removed; the server-side allow-list in
 * backend/server.py::GOOGLE_AUTH_ALLOWED_EMAILS is the only gate.
 */
export default function LoginPage() {
  const initialErr = new URLSearchParams(window.location.search).get("e") || "";
  const [err] = useState(initialErr);

  const startGoogleSignIn = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href =
      `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-navy grid place-items-center px-4">
      <div className="w-full max-w-md bg-warm p-10 border-t-8 border-yellow shadow-2xl">
        <div className="text-cobalt text-[10px] uppercase tracking-[0.32em] mb-1">Indie Law</div>
        <h1 className="text-3xl font-bold text-navy mb-1">Marketing Intelligence</h1>
        <p className="text-sm text-midnight opacity-70 mb-8">
          Sign in with your Indie Law Google account to continue.
        </p>

        {err && (
          <div className="mb-6 text-sm text-red-700 bg-red-700/10 border border-red-700/30 px-4 py-3"
               data-testid="login-error">
            {err}
          </div>
        )}

        <button type="button"
          data-testid="google-signin-btn"
          onClick={startGoogleSignIn}
          className="w-full flex items-center justify-center gap-3 border border-navy/30 bg-white text-navy px-4 py-3 text-sm font-semibold hover:bg-warm-tint transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.6 32.2 29.2 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.8 0 5.4 1.1 7.4 2.8l5.7-5.7C33.5 6.7 29 5 24 5 13.5 5 5 13.5 5 24s8.5 19 19 19 19-8.5 19-19c0-1.2-.1-2.3-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c2.8 0 5.4 1.1 7.4 2.8l5.7-5.7C33.5 6.7 29 5 24 5 16.3 5 9.7 9.4 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 43c5 0 9.5-1.7 12.9-4.5l-6-4.9c-2 1.4-4.4 2.4-7 2.4-5.2 0-9.6-3.3-11.2-8L6.1 32.8C9.4 38.4 16.2 43 24 43z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.6l6 4.9C40.4 35.7 43 30.3 43 24c0-1.2-.1-2.3-.4-3.5z"/>
          </svg>
          Continue with Google
        </button>

        <p className="mt-8 text-xs text-midnight opacity-60">
          Access is restricted to approved Indie Law team members. If you need access, contact your admin.
        </p>
      </div>
    </div>
  );
}
